import React, { Component } from "react";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { withTranslation } from "react-i18next";

class StaticLogoutPage extends Component {
  constructor(props) {
    super(props);
    const root = document.getElementById("root");
    const loginToolbarColor = root.getAttribute("login_page_toolbar_color");
    this.state = {
      errorString: "",
      notifyString: "",
      loginToolbarColor: loginToolbarColor,
    };
  }

  componentDidMount() {}

  render() {
    let { t } = this.props;
    return (
      <div>
        <AppBar
          position="static"
          style={{ background: this.state.loginToolbarColor }}
        >
          <Toolbar>
            <img
              src="login_logo.png"
              alt="Bank logo"
              style={{ maxWidth: "140px", maxHeight: "60px" }}
            />
            {/* <Typography variant="h6" color={"inherit"} >
            {APPNAME}   
          </Typography> */}
          </Toolbar>
        </AppBar>
        <div style={{ textAlign: "center" }}>
          <h3> {t("sessionEnded.label")} </h3>
        </div>
      </div>
    );
  }
}

export default withTranslation()(StaticLogoutPage);
